import {useRef,useState} from 'react';
import {api,ApiError} from '../api';
import {withBuildingScope} from '../ui/building-scope';

export type PendingGalleryMedia={id:string;
 batch_id:string;
 original_file_name:string;
 media_type?:string;
 primary_scan_verdict?:string;
 scan_verdict?:string;
 human_status:string;
 confirmed_development_id?:string|null;
 development_name?:string;
 classification_proposal_id?:string;
 filed_document_id?:string|null;
 approval_blocker?:string;
 review_disposition?:string;
 primary_category_name?:string;
 secondary_category_name?:string;
 tertiary_category_name?:string;
 document_type_name?:string;
 created_at:string;
 file_kind?:string};

export const canApproveMedia=(item:PendingGalleryMedia)=>Boolean(item.confirmed_development_id&&item.classification_proposal_id)&&!item.approval_blocker&&(!item.review_disposition||item.review_disposition==='Active')&&item.primary_scan_verdict==='Clean'&&item.scan_verdict!=='Quarantined';
export function ApproveMediaSelection({items,building,disabled,held,onBusy,onHeld,onSaved}:{items:PendingGalleryMedia[];building?:string|undefined;disabled:boolean;held:boolean;onBusy:(value:boolean)=>void;onHeld:(value:boolean)=>void;onSaved:(message:string)=>void}){
 const inFlight=useRef(false),keys=useRef(new Map<string,string>()),retained=useRef<PendingGalleryMedia[]|undefined>(undefined),[message,setMessage]=useState(''),[uncertain,setUncertain]=useState(false);
 const ready=items.filter(canApproveMedia);
 async function approve(){if(inFlight.current||disabled||(held&&!uncertain))return;inFlight.current=true;const selected=retained.current??ready;retained.current=selected;onBusy(true);setMessage('');let saved=0,unknown=false;const retry:PendingGalleryMedia[]=[];
  try{for(const item of selected){const id=item.classification_proposal_id!;
 if(!keys.current.has(id))keys.current.set(id,crypto.randomUUID());
 try{const result=await api<{id:string;
 status:string}>(withBuildingScope(`/api/document-ingestion/classification-proposals/${id}/review`,building),{method:'POST',body:JSON.stringify({decision:'Approve',idempotencyKey:keys.current.get(id)})});
 if(result.id!==id||result.status!=='Approved')throw Error('Filing receipt not confirmed');
 saved++;
 }catch(error){retry.push(item);
 unknown ||=!(error instanceof ApiError&&error.statusCode>=400&&error.statusCode<500);
 }}
   retained.current=unknown?retry:undefined;setUncertain(unknown);onHeld(unknown);const resultMessage=`${saved} of ${selected.length} filed.${retry.length?' Remaining items need review or retry.':''}`;setMessage(resultMessage);if(!unknown&&saved)onSaved(resultMessage);
  }finally{inFlight.current=false;onBusy(false);}
 }
 return <><button disabled={disabled||(held&&!uncertain)||(!uncertain&&!ready.length)} onClick={()=>void approve()}>{uncertain?'Retry retained approvals':`Approve selected (${ready.length})`}</button>{message&&<span role="status">{message}</span>}</>;
}
